import { lazy, Suspense } from 'react';
import { RouteObject, useRoutes } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { useAuthState } from '~/core/components/contexts/UserContext';
import Loading from '~/core/presentation/layout/global/Loading';
import AdminLayout from '~/core/presentation/layout/admin/Layout';

const DashboardScreen = lazy(() => import('~/features/dashboard/presentation/pages/index/Index'));
const KyoZap = lazy(() => import('~/features/kyozap/Index'));
const TokenPaymentsEnterprisePage = lazy(() => import('~/features/token_payments_enterprise/presentation/pages/TokenPaymentsEnterprisePage'));

function PrivateRouter(): JSX.Element {
  // Sempre chamar hooks primeiro, antes de qualquer condicional
  const { state } = useAuthState();
  
  console.log('🔐 PrivateRouter - Estado de autenticação:', state);
  console.log('🌍 PrivateRouter - URL atual:', window.location.pathname);
  
  const routes: RouteObject[] = [
    {
      path: '/',
      element: <AdminLayout />,
      children: [
        { index: true, element: <DashboardScreen /> },
  { path: 'kyozap', element: <KyoZap /> },
  { path: 'tokens', element: <TokenPaymentsEnterprisePage /> },
      ],
    },
    {
      path: '*',
      element: <AdminLayout />,
      children: [
        { index: true, element: <DashboardScreen /> },
  { path: 'kyozap', element: <KyoZap /> },
  { path: 'tokens', element: <TokenPaymentsEnterprisePage /> },
      ],
    },
  ];

  const element = useRoutes(routes);
  console.log('🎯 PrivateRouter - Elemento sendo renderizado:', element);
  
  // Enquanto estado é UNKNOWN ainda estamos checando token persistido: não redirecionar prematuramente
  if (state.state === 'UNKNOWN') {
    console.log('⏳ Aguardando verificação de autenticação (estado UNKNOWN)');
    return (
      <Suspense fallback={<Loading />}> 
        <Loading />
      </Suspense>
    );
  }

  // Se não autenticado após verificação
  if (state.state !== 'SIGNED_IN') {
    console.log('❌ Usuário não autenticado, redirecionando para login');
    return <Navigate to="/login" replace />;
  }

  // Se usuário está autenticado mas ainda na URL de login, redirecionar para dashboard
  if (window.location.pathname === '/login') {
    console.log('🔄 Usuário autenticado na página de login, redirecionando para dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  console.log('✅ Usuário autenticado, renderizando dashboard');
  
  return (
    <Suspense fallback={<Loading />}>
      {element}
    </Suspense>
  );
}

export default PrivateRouter;
